import React, { FC } from 'react'
import { useTranslation } from 'next-i18next'
import cn from 'classnames'
import Link from 'next/link'
import {
    BillingCartAddress,
    CartAddressRegion,
    CustomerAddress,
    ShippingCartAddress
} from '@pylot-data/fwrdschema'

type Props = {
    address:
        | CustomerAddress
        | (CustomerAddress & Partial<BillingCartAddress | ShippingCartAddress>)
    countryName: string
    hideActions?: boolean
    changeAddressLabel?: string
}

export const AddressCard: FC<Props> = ({
    address,
    countryName,
    hideActions = false,
    changeAddressLabel = 'Change Address'
}) => {
    const { t } = useTranslation(['account'])
    const {
        id,
        city,
        country_code,
        firstname,
        middlename = '',
        lastname,
        postcode,
        region,
        street,
        telephone,
        county
    } = address || {}

    const name = [firstname, middlename, lastname]
        .filter((str) => !!str)
        .join(' ')

    const additionalAddress = `${city}, ${
        region?.region ?? ((region as CartAddressRegion)?.label || '')
    } ${postcode ?? ''}`

    //TODO: add useMemo for map
    const streetRows = street?.map((row, index) => {
        return (
            <span className={cn('street-row')} key={index}>
                {row}
            </span>
        )
    })

    return (
        <div className="box-info">
            <div className="content">
                <div className="address-block">
                    <span className="name">{name}</span>
                    {streetRows}
                    <span className="additionalAddress">
                        {additionalAddress}
                    </span>
                    <span className="country">
                        {countryName || country_code}
                    </span>
                    <span className="telephone">
                        {t('account||account|Tel: ')}
                        <a href={`tel:${telephone}`}>{telephone}</a>
                    </span>
                </div>
            </div>
            <div className={cn({ hidden: hideActions }, 'action-container')}>
                <Link href={`/account/address/edit/${id}`}>
                    {t(`account||account|${changeAddressLabel}`)}
                </Link>
            </div>
        </div>
    )
}
